import { render, staticRenderFns } from "./licensing.vue?vue&type=template&id=80f6d2d8&"
import script from "./licensing.vue?vue&type=script&lang=js&"
export * from "./licensing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports